import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const InstructorUserEditLoader = async (args: LoaderFunctionArgs) => {

    const response = await networkCall(`/users/${ args.params.id }`);

    return { response, id: args.params.id };

};